module.exports = __webpack_public_path__ + "img/pt8.79323d1e.png";